import qs from 'qs';

import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export interface IListCollectorUsers {
  nodes: UserProfile[];
  total: number;
}

export interface IListCollectorUsersParams {
  skip?: number;
  limit?: number;
  full_name?: string;
  email?: string;
  external_id?: string;
  id?: string;
  status?: string[];
  type?: string[];
  sort_by?: 'full_name' | 'email' | 'external_id' | 'id' | 'status' | 'type' | 'organization_ids' | 'client_tags';
  sort_direction?: 'asc' | 'desc';
  client_tags?: string[];
  client_division_ids?: number[];
  date_of_birth_start?: string;
  date_of_birth_end?: string;
}

/**
 * List patients and dependents created by the current Collector (within their client tags).
 * Calls GET /collector/users.
 */
export const listCollectorUsers = async (
  params?: IListCollectorUsersParams,
): Promise<IListCollectorUsers> => {
  const queryString = qs.stringify(params ?? {}, {
    skipNulls: true,
    arrayFormat: 'repeat',
  });
  const { data } = await client.get<IListCollectorUsers>(
    queryString ? `/collector/users?${queryString}` : '/collector/users',
  );
  return data;
};

const COLLECTOR_USER_PAGE_SIZE = 100;

/**
 * True if `managedUserId` is returned from **GET /collector/users** (IDs safe to **PATCH /collector/users/{id}**).
 * The collector’s own user id should not appear here; patching self belongs on **PATCH /collector/me**.
 */
export async function isCollectorManagedUserId(managedUserId: number): Promise<boolean> {
  const target = Number(managedUserId);
  if (!Number.isFinite(target)) return false;

  let skip = 0;
  for (;;) {
    const { nodes, total } = await listCollectorUsers({
      limit: COLLECTOR_USER_PAGE_SIZE,
      skip,
    });
    if (nodes.some((u) => Number(u.id) === target)) {
      return true;
    }
    skip += nodes.length;
    if (nodes.length === 0 || nodes.length < COLLECTOR_USER_PAGE_SIZE || skip >= total) {
      return false;
    }
  }
}
